<template>
  <slide-show :id="id">
    <!-- Premise Types or Icon Label -->
    <div v-if="premiseTypes && premiseTypes.length > 0" class="slider__label">
      <template v-for="(p, idx) in premiseTypes">
        <span :key="`premise-${idx}`" class="slider__label-item">
          <i
            v-if="p.icon"
            :class="`fa-regular fa-${p.icon} slider__label-icon`"
            aria-hidden="true"
          ></i>
          <span v-if="p.type" class="slider__label-text">{{ p.type }}</span>
        </span>
        <span
          v-if="idx < premiseTypes.length - 1"
          :key="`separator-${idx}`"
          class="slider__label-separator"
          aria-hidden="true"
        >
          |
        </span>
      </template>
    </div>
    <div v-else-if="iconLabel" class="slider__label">
      <i
        class="fa-regular fa-briefcase-blank slider__label-icon"
        aria-hidden="true"
      ></i>
      <span class="slider__label-text">{{ iconLabel }}</span>
    </div>

    <!-- Image Slides -->
    <div class="slider">
      <div
        v-for="(image, index) in galleryImages"
        :key="`slide-${index}`"
        class="slider__item"
      >
        <img
          :src="getNormalizedSrc(image)"
          :alt="getNormalizedAlt(image)"
          :loading="index === 0 ? 'eager' : 'lazy'"
        />
      </div>
    </div>

    <!-- Navigation Buttons -->
    <div
      v-if="showNavigation && hasMultipleImages"
      class="slider__nav"
      :aria-label="`${title} navigation`"
    >
      <button
        v-for="(image, index) in galleryImages"
        :key="`nav-${index}`"
        class="slider__nav__button"
        :aria-label="`Go to slide ${index + 1}`"
        type="button"
      />
    </div>
  </slide-show>
</template>

<script>
export default {
  name: "VGallery",
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    showNavigation: {
      type: Boolean,
      default: true,
    },
    showButtons: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "Gallery",
    },
    id: {
      type: String,
      default: () => `slideshow-${Math.random().toString(36).substr(2, 9)}`,
    },
    iconLabel: {
      type: String,
      default: null,
    },
    iconType: {
      type: String,
      default: "briefcase-blank",
    },
    premiseTypes: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    galleryImages() {
      return this.images.length > 0 ? this.images : [];
    },
    hasMultipleImages() {
      return this.galleryImages.length > 1;
    },
  },
  methods: {
    /**
     * Normalize image source - accepts both { src } and { url } formats
     */
    getNormalizedSrc(image) {
      return image.src || image.url || "";
    },
    /**
     * Normalize image alt text - accepts both { alt } and { text } formats
     */
    getNormalizedAlt(image) {
      return image.alt || image.text || this.title;
    },
  },
};
</script>
